import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import * as S from './styled'

const SubmenuBurger = ({ title, submenu }) => {
  const resetScroll = useRef(null)
  useEffect(() => {
    resetScroll.current.scrollTop = 0
  })

  const handleTag = (eventLabel) => {
    if (window && window.dataLayer)
      window.dataLayer.push({
        'event': 'institucional_hamburguer',
        'action': 'clicou_btn',
        'clique': eventLabel
      })
  }


  return (
    <S.SubmenuBurger ref={resetScroll} data-testid="submenuMobile-ul">
      <S.SubmenuTitleContainer data-testid="submenuTitleContainer-div">
          <S.ArrowLeftIcon size={30} visible={false} />
          <S.BackMenu data-testid="backMenu-p">Menu</S.BackMenu>
      </S.SubmenuTitleContainer>
      <S.SubmenuTitle>{title}</S.SubmenuTitle>
      {submenu.map((subitem, index) => (
        <S.SubmenuItem key={index}>
          <S.SubmenuLink
            data-testid="submenuLink-a"
            data-item-text={`${title} > ${subitem.title}`}
            data-item-position="Menu Header"
            data-current-service="Home"
            href={subitem.url}
            target={subitem.url.match(/^https?:\/\//g) ? '_blank' : ''}
            onClick={() => handleTag(subitem.title)}
          >
            {subitem.title}
          </S.SubmenuLink>
        </S.SubmenuItem>
      ))}
    </S.SubmenuBurger>
  )
}

SubmenuBurger.propTypes = {
  title: PropTypes.string,
  submenu: PropTypes.arrayOf(
    PropTypes.shape({
      subitem: PropTypes.shape({
        title: PropTypes.string,
        url: PropTypes.string,
        subtree: PropTypes.array,
      }),
    })
  ),
}

export default SubmenuBurger
